export const environment = {
    production: true,
    apiURL: 'https://api-maklon-staging.kanakafactory.com/api',  
    apiWarehouseURL: 'https://api-warehouse-staging.kanakafactory.com/api',
    apiHumanResourceURL: 'https://api-hr-staging.kanakafactory.com/api',
    baseUrl: 'https://maklon-staging.kanakafactory.com/', 
}
